import { Node } from './';

export class Link implements d3.SimulationLinkDatum<Node> {
    // optional - defining optional implementation properties - required for relevant typing assistance
    index?: number;
    value?: number; //INFO: This can be used for dynamic values of force link properties

    // must - defining enforced implementation properties
    source: Node;
    target: Node;
    label!: string;

    constructor(source: Node, target: Node) {
        // debugger;
        this.source = source;
        this.target = target;
    }
    get linkClass() {
        if (this.source.disabled || this.target.disabled) {
            return 'link link-disabled';
        } else {
            return 'link';
        }
    }
}
